import React from 'react';

import requireAuth from '~components/hocs/requireAuth';
import SearchPerformance, { hasSearchPerformanceAccess } from '~features/SearchPerformance';
import AdminTemplate from '../layout/AdminTemplate';

const META_TAGS = {
  title: 'Search Performance - Prerender.io',
};

function SearchPerformancePage() {
  return (
    <AdminTemplate metaTags={META_TAGS}>
      <SearchPerformance />
    </AdminTemplate>
  );
}

export default requireAuth(SearchPerformancePage, hasSearchPerformanceAccess);
